import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import ClubDetailPage from "./pages/ClubDetailPage";
import EventDetailPage from "./pages/EventDetailPage";
import BookingPage from "./pages/BookingPage";
import ReviewSummaryPage from "./pages/ReviewSummaryPage";
import BottleDetailPage from "./pages/BottleDetailPage";
import BottleAvailabilityPage from "./pages/BottleAvailabilityPage";

export default function App() {
  
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <Routes>
        <Route path="/" element={<ClubDetailPage />} />
        <Route path="/club/:id" element={<ClubDetailPage />} /> /********* Host Profile Detail Page *********/
        <Route path="/club/event/:eventId" element={<EventDetailPage />} />/********* Club Event Detail Page *********/
        <Route path="/event/:eventId" element={<EventDetailPage />} />
        <Route path="/bottle/:eventId" element={<BottleDetailPage />} />
        <Route path="/bottle/:eventId/availability" element={<BottleAvailabilityPage />} />
        <Route path="/bottle/:eventId/review" element={<ReviewSummaryPage />} />
        <Route path="/table/:eventId" element={<EventDetailPage />} />
        <Route path="/booking/:eventId" element={<BookingPage />} />
        <Route path="/booking/:eventId/review" element={<ReviewSummaryPage />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
